import React from "react";
import { cn } from "@/lib/utils";
import { CompactHintTrigger } from "./compact-hint-trigger";

interface CompactFieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  /** Ayuda en tooltip en el gutter entre label y control. No se pinta bajo el control. */
  hint?: string;
  /** Estado vivo bajo el control (stock, lecturas). Se oculta si hay error. */
  caption?: string;
  /** Oculta el label en grid (celda DataTable; el encabezado de columna actúa como etiqueta). */
  labelVisuallyHidden?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const CompactField: React.FC<CompactFieldProps> = ({
  label,
  htmlFor,
  required = false,
  error,
  hint,
  caption,
  labelVisuallyHidden = false,
  className,
  children,
}) => {
  return (
    <div
      className={cn(
        "compact-field",
        labelVisuallyHidden && "compact-field--control-only",
        className,
      )}
    >
      <label
        htmlFor={htmlFor}
        className={cn("compact-label", labelVisuallyHidden && "sr-only")}
        title={label}
      >
        {label}
        {required ? <span className="text-red-500"> *</span> : null}:
      </label>
      <span className="compact-hint-slot">
        {hint ? <CompactHintTrigger text={hint} label={label} /> : null}
      </span>
      <div className="compact-field-control">
        {children}
        {error ? (
          <p className="compact-field-error" role="alert">
            {error}
          </p>
        ) : null}
        {caption && !error ? <p className="compact-hint">{caption}</p> : null}
      </div>
    </div>
  );
};
